module.exports = {
    SAVE_AUDIT: 'SAVE_AUDIT',
    GET_AUDIT: 'GET_AUDIT',
    GET_AUDIT_SUCCESS: 'GET_AUDIT_SUCCESS',  
    DELETE_AUDIT: 'DELETE_AUDIT'
}